import { render, staticRenderFns } from "./Convention.vue?vue&type=template&id=7ce0ec74"
import script from "./Convention.vue?vue&type=script&lang=js"
export * from "./Convention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports